import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

import DefaultInput from 'src/components/DefaultInput';

export const TopHeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  marginBottom: '2.4rem',
});

export const ETHDYDXContainer = styled('div')(({ theme }) => ({
  padding: '2.4rem',

  borderRadius: '1rem',

  color: theme.colors.base01,
  backgroundColor: theme.colors.base06,
}));

export const ETHDYDXTopContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  marginBottom: '2rem',

  color: theme.colors.base01,
}));

export const ETHDYDXTopLeftContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base02,
}));

export const ETHDYDXTopLeftAmountContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const ETHDYDXTopRightContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1rem',
});

export const AmountPresetButton = styled('button')(({ theme }) => ({
  width: '4.4rem',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  padding: '0.4rem 0',

  border: 'none',

  borderRadius: '0.8rem',

  color: theme.colors.base01,
  backgroundColor: theme.colors.base04,

  '&:hover': {
    backgroundColor: theme.colors.base05,
    cursor: 'pointer',
  },
}));

export const ETHDYDXBodyContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const TokenContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1.2rem',
});

export const TokenRightContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',

  rowGap: '0.4rem',
});

export const IconContainer = styled('div')({
  width: '4.8rem',
  height: '4.8rem',

  '& > svg': {
    width: '4.8rem',
    height: '4.8rem',
  },
});

export const TokenTextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  rowGap: '0.6rem',
});

export const StyledInput = styled(DefaultInput)({
  height: '3rem',
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  color: theme.colors.base02,
}));

export const PathwayContainer = styled('div')({
  position: 'relative',

  marginBottom: '1.2rem',
});

export const DownArrowIconContainer = styled('div')({
  position: 'absolute',

  bottom: '-4.1rem',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const SwapInfoContainer = styled('div')({
  marginBottom: '1.2rem',
});

export const SwapButtonContainer = styled('div')({
  width: 'calc(100% - 8rem)',

  position: 'absolute',
  bottom: '4rem',
});

export const DetailContainer = styled('div')({
  width: 'calc(100% - 8rem)',

  position: 'absolute',
  bottom: '13.4rem',
});

export const TitleContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  '&.MuiCircularProgress-root': {
    color: theme.colors.base01,
  },
}));

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',

  borderRadius: '2rem',
}));
